<template>
	<div class="page-container" ref="scrollDom">
		<div>
			<div v-if="isloading" class="isloading">
				<loading size="24px">加载中...</loading>
			</div>
			<div v-else>
				<no-list v-if="orderList.length == 0" text="没有找到相关门店"></no-list>
			</div>

			<div class="history-list">
				<div class="history-item" v-for="(item, index) in orderList" :key="index">
					<div class="order">
						<div>
							订单(<span>{{ item["orderId"] }})</span>
						</div>
						<div>{{ item["order_status_str"] }}</div>
					</div>

					<div class="flowId" v-if="item['flowId']">
						<div class="title">口令:</div>
						<div class="text" v-clipboard:error="onError" v-clipboard:copy=" item['flowId']"
							v-clipboard:success="onCopy">
							“{{ item["flowId"] }}”
						</div>
					</div>

					<div class="name" >
						“{{ item["name"] }}”
					</div>

					<p>{{ item["addressDetail"] }}</p>
					<p>{{ item["lastPayTime"] }}</p>

					<div class="name" v-if="item['flowId']" style="font-weight: bold; font-size: 25px;color: #07c160;"
						v-clipboard:error="onError" v-clipboard:copy="'啡快:' +item['products'] +'\n取餐口令:' +item['flowId'] +'\n门店:' +item['storeName']+'\n取餐地址:' +item['addressDetail'] +'\n'" v-clipboard:success="onCopy">
						复制口令
					</div>



					<div v-if="item['order_status_str'] === '待支付'" class="btn-box">
						<div class="btn-left" @click="nextPay(item['orderId'], item['storeId'])">
							前往支付
						</div>
						<div class="btn-right" @click="stopPay(item['orderId'])">
							取消订单
						</div>
					</div>
					<div v-if="
              item['order_status_str'] === '已完成' ||
              item['order_status_str'] === '待取单' ||
              item['order_status_str'] === '已接单'
            " class="btn-box">
						<div class="btn-left" @click="gotDtl(item['orderId'])">
							查看详情
						</div>
						<div class="btn-left" @click="sharecode(item['orderId'])">
							晒口令
						</div>
						<div class="btn-right" @click="share_friend(item['orderId'], '')">
							好友代取
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		loading
	} from "vant";
	import BScroll from "@better-scroll/core";
	//import clipboard from 'clipboard';

	import {
		getOrder,
		againPay,
		cancelPay,
		share_code,
		share
	} from "@/api";
	import store from '@/store';

	export default {
		data() {
			return {
				isloading: true,
				orderList: [],
			};
		},
		methods: {
			gotDtl(id) {
				this.$router.push({
					name: "orderDtl",
					query: {
						id: id,
					},
				});
			},
			onCopy() {
				this.$msg("口令已复制");
			},
			onError() {
				this.$msg("您的设备暂不支付复制");
			},
			//   againPay
			nextPay(orderId, storeId) {
				againPay(orderId, storeId).then((d) => {
					store.commit('setorderId', d.data.orderId);
					location.href = d.data.alipay;
				});
			},
			stopPay(orderId) {
				cancelPay(orderId).then(() => {
					this.$msg("取消成功");
					this.init();
				});
			},

			sharecode(orderId) {
				share_code(orderId).then((d) => {
					this.imgurl = d.data.imgurl;
					this.$msg("口令复制成功");

					this.$copyText(this.imgurl).then(
						function(e) {
							console.log(e);
						},
						function(e) {
							console.log(e);
						}
					);
				});
			},
			share_friend(orderId, name) {
				share(orderId, name).then((d) => {
					this.shareurl = d.data.share_url;
					this.$msg("口令复制成功");

					this.$copyText(this.shareurl).then(
						function(e) {
							console.log(e);
						},
						function(e) {
							console.log(e);
						}
					);
				});
			},
			init() {
				getOrder().then((d) => {
					this.orderList = [...d.data];

					this.$nextTick(() => {
						this.isloading = false;
						this.leftScroll = BScroll(this.$refs["scrollDom"], {
							click: true,
						});
					});
				});
			},
		},

		components: {
			loading,
		},
		created() {
			this.init();
		},
	};
</script>

<style lang="scss" scoped>
	.isloading {
		padding: 100px 0;
		text-align: center;
	}

	.page-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		min-width: 0;
		overflow: hidden;
	}

	.history-list {
		padding: 0 30px;

		.history-item {
			padding: 30px 0;
			border-bottom: 1px solid #ddd;

			.order {
				display: flex;
				justify-content: space-between;
				margin-bottom: 20px;
				color: #666;
			}

			.name {
				font-size: 28px;
			}

			.flowId {
				margin: 20px 0;

				.text {
					font-size: 60px;
					font-weight: bold;
					text-align: center;
				}
			}

			p {
				font-size: 24px;
				margin: 0;
				color: #666;
				transform: scale(0.83);
				transform-origin: left;
			}

			.btn-box {
				display: flex;
				justify-content: flex-end;
				margin-top: 30px;

				.btn-left,
				.btn-right {
					margin-left: 30px;
					width: 190px;
					height: 60px;
					line-height: 60px;
					border-radius: 30px;
					text-align: center;
					box-sizing: border-box;
				}

				.btn-left {
					background: #5bad70;
					color: #fff;
				}

				.btn-right {
					border: 1px solid #5bad70;
					color: #5bad70;
				}
			}
		}
	}
</style>
